var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn logo",
    clipPath: "url(#clip0_1535_6407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.8 0H7.2C3.22355 0 0 3.22355 0 7.2V40.8C0 44.7765 3.22355 48 7.2 48H40.8C44.7765 48 48 44.7765 48 40.8V7.2C48 3.22355 44.7765 0 40.8 0Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3125 16.4062C15.2282 16.4062 16.7812 14.8532 16.7812 12.9375C16.7812 11.0218 15.2282 9.46875 13.3125 9.46875C11.3968 9.46875 9.84375 11.0218 9.84375 12.9375C9.84375 14.8532 11.3968 16.4062 13.3125 16.4062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.875 18.1875V36.75V18.1875ZM13.3125 18.1875V36.75V18.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 18.1875V36.75M13.3125 18.1875V36.75",
    stroke: "white",
    strokeWidth: 6.1875
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.875 26.4375C25.875 24.5625 27.0938 22.6875 29.25 22.6875C31.5 22.6875 32.3438 24.375 32.3438 26.9062V36.75H38.5312V26.1562C38.5312 20.4375 35.5312 17.8125 31.4062 17.8125C28.2188 17.8125 26.625 19.5938 25.875 20.8125",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_6407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/LinkedIn-logo.a3a22db587ae199980fb8982a54766fa.svg";
export { ForwardRef as ReactComponent };